import React, { memo, Fragment } from 'react'
import { usePrincipleCard, PrincipleCardProps } from './usePrincipleCard'
import blockContentToHtml from '@sanity/block-content-to-html'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import styles from './PrincipleCard.module.scss'

const PrincipleCard: React.FC<PrincipleCardProps> = (
  props: PrincipleCardProps
) => {
  const { title, description, icon, iconPrefix } = usePrincipleCard(props)

  return (
    <div className={`${styles['principle-card']} d-flex`}>
      <div className={`${styles.icon} flex-shrink-0`}>
        <FontAwesomeIcon icon={[iconPrefix || 'fas', icon || 'question']} />
      </div>
      <div>
        <h3>{title}</h3>
        {description ? (
          <div
            className={styles.description}
            dangerouslySetInnerHTML={{
              __html: Array.isArray(description)
                ? blockContentToHtml({
                    blocks: description,
                  })
                : `<p>${description}</p>`,
            }}
          ></div>
        ) : (
          <Fragment />
        )}
      </div>
    </div>
  )
}

export default memo(PrincipleCard)
